import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type RunBackendJobOperationCreateJobMutationVariables = Types.Exact<{
  input: Types.MutationCreateJobInput;
}>;


export type RunBackendJobOperationCreateJobMutation = { __typename: 'Mutation', createJob: { __typename: 'Job', id: string } };

export type RunBackendJobOperationCancelJobMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RunBackendJobOperationCancelJobMutation = { __typename: 'Mutation', cancelJob: { __typename: 'Job', id: string } };

export type RunBackendJobOperationGetJobStateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RunBackendJobOperationGetJobStateQuery = { __typename: 'Query', job: { __typename: 'Job', id: string, progress?: number | null, state: Types.JobState } };

export type RunBackendJobOperationJobDetailsFragment = { __typename: 'Job', id: string, output?: any | null, state: Types.JobState };

export type RunBackendJobOperationGetJobDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RunBackendJobOperationGetJobDetailsQuery = { __typename: 'Query', job: { __typename: 'Job', id: string, output?: any | null, state: Types.JobState } };

export const RunBackendJobOperationJobDetailsFragmentDoc = gql`
    fragment runBackendJobOperationJobDetails on Job {
  id
  output
  state
}
    `;
export const RunBackendJobOperationCreateJobDocument = gql`
    mutation runBackendJobOperationCreateJob($input: MutationCreateJobInput!) {
  createJob(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunBackendJobOperationCreateJobGQL extends Apollo.Mutation<RunBackendJobOperationCreateJobMutation, RunBackendJobOperationCreateJobMutationVariables> {
    override document = RunBackendJobOperationCreateJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunBackendJobOperationCancelJobDocument = gql`
    mutation runBackendJobOperationCancelJob($id: ID!) {
  cancelJob(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunBackendJobOperationCancelJobGQL extends Apollo.Mutation<RunBackendJobOperationCancelJobMutation, RunBackendJobOperationCancelJobMutationVariables> {
    override document = RunBackendJobOperationCancelJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunBackendJobOperationGetJobStateDocument = gql`
    query runBackendJobOperationGetJobState($id: ID!) {
  job(id: $id) {
    id
    progress
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunBackendJobOperationGetJobStateGQL extends Apollo.Query<RunBackendJobOperationGetJobStateQuery, RunBackendJobOperationGetJobStateQueryVariables> {
    override document = RunBackendJobOperationGetJobStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunBackendJobOperationGetJobDetailsDocument = gql`
    query runBackendJobOperationGetJobDetails($id: ID!) {
  job(id: $id) {
    ...runBackendJobOperationJobDetails
  }
}
    ${RunBackendJobOperationJobDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RunBackendJobOperationGetJobDetailsGQL extends Apollo.Query<RunBackendJobOperationGetJobDetailsQuery, RunBackendJobOperationGetJobDetailsQueryVariables> {
    override document = RunBackendJobOperationGetJobDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }